import { render, staticRenderFns } from "./FormGenerator.vue?vue&type=template&id=dcb1e2f4"
import script from "./FormGenerator.vue?vue&type=script&lang=js"
export * from "./FormGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports